import styles from "./DetailZoneActions.module.scss";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import useFavoriteZone from "../../model/useFavoriteZone";
import { useEffect, useState } from "react";
import { PARK_MACHINE_TYPE } from "../../constants";
import useBuyFormStore from "../../stores/useBuyFormStore";

type Props = {
    sectionCode: string;
    section: any;
    sectionId: string;
    featureType: "parkingZone" | "parkingMachine";
    properties: any;
    forceReload?: () => void;
    detailZone?: any;
};

const DetailZoneActions = ({ sectionCode, section, sectionId, featureType, properties, forceReload, detailZone }: Props) => {
    const { t } = useTranslation();
    const { zones, add, deleteByIndex } = useFavoriteZone();
    const formStore = useBuyFormStore();

    useEffect(() => {
        const zone = zones.find(
            (zone) => zone.id === detailZone.properties.sectionID || zone.id === detailZone.properties.parkMachineID
        );
        setIsFavorite(zone);
    }, [zones, detailZone]);

    const [isFavorite, setIsFavorite] = useState<boolean>(false);

    const handleFavorite = () => {
        if (!isFavorite) {
            add({ id: sectionId, json: JSON.stringify(section) }).then(() => {
                forceReload?.();
            });
        } else {
            deleteByIndex("id", sectionId).then(() => {
                forceReload?.();
            });
        }
    };

    const buyShort = featureType === "parkingZone" ? "pz" : properties.parkMachineType === PARK_MACHINE_TYPE.infobox ? "ib" : "pm";

    const resetStore = () => {
        formStore.resetForm();
    }

    return (
        <div className={styles.actions}>
            <button className={`${styles.addToFavorite} ${isFavorite ? styles.active : ""}`} onClick={handleFavorite}>
                <span>
                    <Icon.Star size={18} color={isFavorite ? "#FFFFFF" : "#1D4F8B"} />
                </span>
            </button>

            {section?.tariffInfo?.maxHour > 0 && (
                <Link to={`/buy/${buyShort}/${sectionCode}`} className={`${styles.buyTicket}`} onClick={resetStore}>
                    <Icon.ShoppingBasket size={16} color={"#FFFFFF"} />
                    &nbsp;&nbsp;{t("home.DetailZoneActionsComponent.buy")}
                </Link>
            )}
        </div>
    );
};

export default DetailZoneActions;
